import { render, staticRenderFns } from "./ManageConsultant.vue?vue&type=template&id=3ecd94d3&scoped=true"
import script from "./ManageConsultant.vue?vue&type=script&lang=js"
export * from "./ManageConsultant.vue?vue&type=script&lang=js"
import style0 from "./ManageConsultant.vue?vue&type=style&index=0&id=3ecd94d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecd94d3",
  null
  
)

export default component.exports